import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify';
import { toast } from "react-toastify";
import { addNewUserApi, otpByPassApi, switchRoleApi } from '../../../../utils/ApiEndpointFunctions';
import ReactPaginate from 'react-paginate'
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useAdminContext } from '../../../../context/adminContext';
import { capitalizeWords, getRoleName } from '../../../../utils/HelperFuncitons';
import LimitPagination from '../../../common/LimitPagination';
import { S3_URL } from '../../../../utils/BaseUrl';
import ImageViewModal from '../../../common/Modal/ImageViewModal';
import CommonTable from '../../../common/Table/CommonTable';
import moment from 'moment';
import ReactSelect from 'react-select';
import { Spinner } from 'react-bootstrap';
import ByPassOtpConfirmationModal from '../../../common/Modal/ByPassOtpConfirmationModal';
import AddOrUpdateDetails from '../../../common/Modal/AddOrUpdateDetails';
import { newCustomerInitialValue, newCustomerValidationSchema } from '../../../common/Validation';
import { useFormik } from 'formik';
// import { Modal } from 'bootstrap';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';




function DriverTable(props) {
  // Add import for API function

  const [roleChangeLoading, setRoleChangeLoading] = useState(false);
  const { setConfirmStatus, enabledDesabledModalId, setEnableDisable, getUsers, loader, users, selectedPage, page, totalCount, handlePageClick, debouncedOnChange, countryOptions, cityOptions, filterCountry, filterCites, handleCityChange, handleCountryChange, searchFormik } = props;
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const imageViewModalId = "imageViewModalId"
  const  byPassConfirmModalId = 'byPassConfirmModal'
  const changeRoleModalId = "changeRoleModalId"
  const driverBankModal2 = "driverBankModal2"
  const [detailsType,setDetailsType] = useState({type:"",loading:false})
  const [selectedImg, setSelectedImg] = useState("")
  const [selectedUserForRole, setSelectedUserForRole] = useState(null);
  const [selectedRole, setSelectedRole] = useState("");
  const { limit, adminDetail } = useAdminContext();
  const [isChangeRoleModalOpen, setIsChangeRoleModalOpen] = useState(false);
  const [selectedCustomer,setSelectedCustomer]= useState({id:"",type:""})
  const [activeTab, setActiveTab] = useState('customer');


  const isRestaurant = searchParams.get('type') === 'restaurant';

  const confirmApproveOrReject = (status, userId, role) => {
    setConfirmStatus({ status, userId, role })
    document.getElementById('confirmModalBtn').click()
  }

  const enableDisableHandler = (status, userId, role) => {
    setEnableDisable({ status, userId, type: "partnerUser" })
  }

  const handleRoleChangeSubmit = async () => {
    if (!selectedUserForRole || !selectedRole) return;
    setRoleChangeLoading(true);

    try {
      const payload = {
        id: selectedUserForRole.id,   // ✅ user ki ID
        role: selectedRole            // ✅ selected role
      };

      // API call
      const res = await switchRoleApi(payload);

      // Refresh user list
      if (typeof getUsers === "function") getUsers();

      // Success toast
      toast.success(res?.data?.message);
      console.log("res", res)
      setIsChangeRoleModalOpen(false);

    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message);
    } finally {
      setRoleChangeLoading(false);
    }
  };

  const handleByPassOtp = async()=>{
      try {
        let res;
       if(selectedCustomer){
         res = await otpByPassApi(selectedCustomer)
       }
        if(res.status===200){
          console.log("resssss??????/",res?.data)
          toast.success(res?.data?.message)
        }
      } catch (error) {
        console.log("error",error)
        toast.error(error?.response?.data?.message)
      }
    }

     function handleInputChange(name, value, formik, input) {
    if (input === "select") {
      formik.setFieldValue(name, value || "");
    } else if (input === "phone") {
      formik.setFieldValue(name, value);
    }
  }


  async function handleCustomerDetailSubmit(payload, apiEndPoint) {
    try {
      console.log("in try block")
      setDetailsType({ ...detailsType, loading: true })
      const res = await apiEndPoint({ ...payload, })
      if (res?.status == 200 || res?.status == 201) {
        getUsers(1,limit)
        document.getElementById(detailsFields[activeTab]?.modalId)?.click()
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
    }
    setDetailsType({ ...detailsType, loading: false })
  }

  const typeOptions = [
    // { label: "User", value: "User" },
    { label: "PartnerUser", value: "PartnerUser" }
  ];

  const detailsFields = {
    "customer": {
      format: [
        { name: "type", label: "Type", type: "select", options: typeOptions, handleOnChange: (...values) => handleInputChange(...values, "select") },
        { name: "phone", label: "Phone Number", type: "phone", handleOnChange: (...values) => handleInputChange(...values, "phone") },
      ],
      initialvalue: newCustomerInitialValue,
      validationSchema: newCustomerValidationSchema,
      handleSubmit: (values) => handleCustomerDetailSubmit({...values,type:values?.type?.value}, addNewUserApi),
      modalId: driverBankModal2
              }            
          }

  const customerDetailsFormik = useFormik({
    initialValues: detailsFields?.[activeTab]?.initialvalue,
    validationSchema: detailsFields?.[activeTab]?.validationSchema,
    onSubmit: detailsFields?.[activeTab]?.handleSubmit
  })


  const headerData = [
    { name: "S.No", className: "col-1", key: "index" },
    { name: "Name", className: "col-3", key: "name" },
    { name: "Email ID", className: "col-1", key: "email" },
    { name: "Class", className: "col-1", key: "class" },
    { name: "Contact", className: "col-1", key: "phone" },
    { name: "Country", className: "col-1", key: "country" },
    { name: "City", className: "col-1", key: "city" },
    { name: "Role", className: "col-1", key: "role" },
    { name: "Status", className: "col-1", key: "approvalStatus" },
    { name: "Registered On", className: "col-1", key: "createdAt" },
    { name: "Login status", className: "col-1", key: "isActive" },
    { name: "Action", className: "col-1", key: "action" },
  ]

  const restaurantHeaderData = [
    { name: "S.No", className: "col-1", key: "index" },
    { name: "Name", className: "col-3", key: "name" },
    { name: "Email ID", className: "col-1", key: "email" },
    { name: "Contact", className: "col-1", key: "phone" },
    { name: "Country", className: "col-1", key: "country" },
    { name: "City", className: "col-1", key: "city" },
    { name: "Role", className: "col-1", key: "role" },
    { name: "Status", className: "col-1", key: "approvalStatus" },
    { name: "Registered On", className: "col-1", key: "createdAt" },
    { name: "Login status", className: "col-1", key: "isActive" },
    { name: "Action", className: "col-1", key: "action" },
  ]

  const tableData = users?.map((user, index) => ({
    index: index + 1,
    name: (
      <>
        <div className="avatar avatar-xs align-middle me-2">
          <img
            className="avatar-img rounded-circle"
            src={!user.profileImage ? "/images/profiledp.png" : `${S3_URL}/${user?.profileImage}`}
            alt="img"
            data-bs-toggle="modal"
            data-bs-target={`#${imageViewModalId}`}
            style={{ cursor: 'pointer' }}
            onClick={() => { setSelectedImg(!user.profileImage ? "/images/profiledp.png" : `${S3_URL}/${user?.profileImage}`) }}
          />
        </div>
        <Link className="text-primary" to={
          user.role?.includes?.("driver") ? `/partners/driver/${user.id}`
            : user.role?.includes?.("hire") ? `/partners/rental/${user.id}`
              : user.role?.includes?.("restaurant") ? `/partners/restaurent/${user.id}`
                : user.role?.includes?.("salesAgent") ? `/partners/salesAgent/${user.id}`
                  : user.role?.includes?.("busOperator") ? `/partners/busOperator/${user.id}`
                    : user.role?.includes?.("fleetOwner") ? `/partners/fleetOwner/${user.id}`
                      : user.role?.length === 0 ? `/partners/profileDetails/${user.id}`
                        : location.pathname + location.search
        } style={{ textWrap: "noWrap" }}>{capitalizeWords(user?.name)}</Link>
      </>
    ),
    email: user?.email || "-",
    class: user?.vehicles[0]?.category?.category || " ",
    phone: user?.phone || "-",
    country: user?.country || "-",
    city: user?.city || "-",
    role: getRoleName(user),
    approvalStatus: user?.approvalStatus ? capitalizeWords(user?.approvalStatus) : "",
    createdAt: user?.createdAt ? moment(user?.createdAt).format("LL") : "-",
    isActive: user?.isActive ? "Enabled" : <div className='d-flex flex-column'><span>Disabled</span><span className='fs-5'>({user?.disableReason})</span></div>,
    action: (
      <>
        <div className="dropdown">
          <button
            className=" border-0 bg-white"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-three-dots-vertical"
              viewBox="0 0 16 16"
            >
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            </svg>
          </button>
          <ul className="dropdown-menu" style={{ zIndex: "1000" }}>
            {(user?.approvalStatus === "pending" || user?.approvalStatus === "rejected") && <li onClick={() => confirmApproveOrReject('approved', user?.id, user?.role[0], user?.lastActive)}>
              <div className="dropdown-item" style={{ cursor: "pointer" }}>
                Approve
              </div>
            </li>}
            {(user?.approvalStatus === "pending" || user?.approvalStatus === "approved") && <li onClick={() => confirmApproveOrReject('rejected', user?.id, user?.role[0], user?.lastActive)}>
              <div className="dropdown-item" style={{ cursor: "pointer" }}>
                Reject
              </div>
            </li>}
            {user?.isActive === false && <li
              data-bs-toggle="modal"
              data-bs-target={`#${enabledDesabledModalId}`}
              onClick={() =>
                enableDisableHandler('approved', user?.id)
              }
            >
              <div className="dropdown-item" style={{ cursor: "pointer" }} >
                Enable
              </div>
            </li>}

            {user?.isActive === true && <li
              data-bs-toggle="modal"
              data-bs-target={`#${enabledDesabledModalId}`}
              onClick={() => {
                enableDisableHandler('rejected', user?.id);
              }}
            >
              <div className="dropdown-item" style={{ cursor: "pointer" }} >
                Disable
              </div>
            </li>}
            {/* Change Role Option */}
            <li
              onClick={() => {
                setSelectedUserForRole(user);
                setSelectedRole(user?.role?.[0] || "");
                setIsChangeRoleModalOpen(true);
              }}
            >
              <div className="dropdown-item" style={{ cursor: "pointer" }}>
                Change Role
              </div>
            </li>

             <li className="dropdown-item" >
            <div
              data-bs-toggle="modal"
              data-bs-target={`#${byPassConfirmModalId}`}
              onClick={() => { setSelectedCustomer({
                id:user?.id,
                type:"PartnerUser"
              }) }}
              style={{ cursor: "pointer" }}
            >
              By Pass Otp
            </div>
          </li>

          </ul>
        </div>
        {/* Change Role Modal */}
        {isChangeRoleModalOpen && (
          <div className="modal-backdrop-custom">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">Change Role</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsChangeRoleModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  {selectedUserForRole && (
                    <form className="d-flex flex-column gap-3">
                      <div>
                        <label className="form-label">User Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={capitalizeWords(selectedUserForRole?.name)}
                          readOnly
                        />
                      </div>
                      <div>
                        <label className="form-label">Select Role</label>
                        <select
                          className="form-select"
                          value={selectedRole}
                          onChange={(e) => setSelectedRole(e.target.value)}
                        >
                          <option value="driver">Driver</option>
                          <option value="hire">Car Rental</option>
                          <option value="restaurant">Restaurant</option>
                          <option value="salesAgent">Sales Agent</option>
                          <option value="busOperator">Bus Operator</option>
                          <option value="fleetOwner">Fleet Owner</option>
                        </select>
                      </div>
                      <div className="text-center">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleRoleChangeSubmit}
                          disabled={roleChangeLoading}
                        >
                          {roleChangeLoading ? <Spinner /> : "Submit"}
                        </button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
            <div
              className="modal-overlay"
              onClick={() => setIsChangeRoleModalOpen(false)}
            ></div>

            <style jsx>{`
  .modal-backdrop-custom {
    position: fixed;
    top: 0; 
    left: 0; 
    right: 0; 
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.05); 
    z-index: 1050;
    border: none;
  }
  .modal-overlay {
    position: fixed;
    top: 0; 
    left: 0; 
    right: 0; 
    bottom: 0;
    z-index: -1;
  }
  .modal-content {
    box-shadow: none !important; 
  }
`}</style>
          </div>
        )}

      </>
    ),
  }))

  useEffect(() => {
    if (adminDetail?.countryId) {
      filterCites(adminDetail.countryId);
    }

    if (adminDetail?.role === "superAdmin") {
      filterCountry();
    }
  }, [adminDetail]);



  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="d-flex justify-content-between flex-wrap align-items-center mt-3 mt-lg-0">
        <LimitPagination getData={getUsers} />
        <div className="d-flex gap-2" style={{ display: "-webkit-inline-box" }}>
          {/* ...existing code... */}
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="city" className="form-label">Country</label>
            <ReactSelect className='reactSelectMinWidth' isDisabled={adminDetail?.role !== "superAdmin"} options={countryOptions} value={searchFormik?.values?.countryId} onChange={handleCountryChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Countries Available'} />
            {searchFormik?.touched?.countryId && searchFormik?.errors?.countryId ? (<div className='req-error'>{searchFormik?.errors?.countryId}</div>) : null}
          </div>
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="city" className="form-label">City</label>
            <ReactSelect className='reactSelectMinWidth' options={cityOptions} isDisabled={!searchFormik?.values?.countryId} value={searchFormik?.values?.cityId} onChange={handleCityChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Cities Available'} />
            {searchFormik?.touched?.cityId && searchFormik?.errors?.cityId ? (<div className='req-error'>{searchFormik?.errors?.cityId}</div>) : null}
          </div>
          <div className='d-flex align-items-center gap-2'>
            <button
              className="btn btn-primary"
              onClick={() => { searchFormik.resetForm(); }}
              disabled={!searchFormik?.values?.countryId}
            >
              Reset filter
            </button>
          </div>
          <div className="position-relative my-3 d-flex justify-content-between ">
            <input
              className="form-search me-3"
              type="search"
              name="searchField"
              id=""
              placeholder="Search"
              onChange={debouncedOnChange}
            />
          </div>

          <div className='d-flex align-items-center justify-content-center' ><button className='btn btn-primary' data-bs-toggle="modal" data-bs-target={`#driverBankModal2`} onClick={() => setActiveTab("customer")} >Add</button></div>

        </div>
      </div>
      <CommonTable headers={isRestaurant ? restaurantHeaderData : headerData} data={tableData} loading={loader} />
      <ImageViewModal imgUrl={selectedImg} modalId={imageViewModalId} />
      {totalCount > limit ? (
        <div className="d-flex justify-content-center">
          <ReactPaginate
            nextLabel="Next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            pageCount={page}
            previousLabel="< Previous"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName={"active"}
            forcePage={selectedPage - 1}
          />
        </div>
      ) : (
        ""
      )}
      {/* Remove lingering modal backdrop if present */}
      {/* <script dangerouslySetInnerHTML={{__html:`setTimeout(function(){var bd=document.querySelect
      or('.modal-backdrop');if(bd){bd.parentNode.removeChild(bd);document.body.classList.remove('modal-open');document.body.style='';}},500);`}} /> */}
      <AddOrUpdateDetails formik={customerDetailsFormik} dataFormat={detailsFields[activeTab]?.format} detailsFor={detailsType?.type} addLoader={detailsType?.loading} modalId={driverBankModal2} />
      <ByPassOtpConfirmationModal modalId={byPassConfirmModalId} handleConfirm={handleByPassOtp} />
    </>
  )
}

export default DriverTable